// extracted by mini-css-extract-plugin
export default {"td":"PersonalizacaoPontoIndex_td__wZb+5","inscricao":"PersonalizacaoPontoIndex_inscricao__8odg5"};